import { permissionsKeyMap, userActions } from './permissionKeys';

// Ground Team preset permissions:
// - Can see facilities (school, mosque, hospital, orphanage)
// - Can see WeConnect beneficiaries page only
// - Can add/edit beneficiaries
// - No donor info access
export const groundTeamPermissions = {
  // No donor permissions
  [permissionsKeyMap.donor.children.donors]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  // No pledge permissions (donor-facing money promises)
  [permissionsKeyMap.pledge.children.pledges]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  // WeConnect - only beneficiaries page
  [permissionsKeyMap.sponsorship.children.sponsorships]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  [permissionsKeyMap.sponsorship.children.beneficiaries]: {
    [userActions.read]: true,
    [userActions.create]: true,
    [userActions.update]: true,
    [userActions.delete]: false
  },
  [permissionsKeyMap.sponsorship.children.sponsorshipManagement]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  [permissionsKeyMap.sponsorship.children.sponsorshipDonation]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  [permissionsKeyMap.sponsorship.children.sponsorshipReports]: {
    [userActions.read]: false
  },
  [permissionsKeyMap.sponsorship.children.sponsorshipValues]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  // Facilities permissions (full access)
  [permissionsKeyMap.facilities.children.school]: {
    [userActions.read]: true,
    [userActions.create]: true,
    [userActions.update]: true,
    [userActions.delete]: false
  },
  [permissionsKeyMap.facilities.children.mosque]: {
    [userActions.read]: true,
    [userActions.create]: true,
    [userActions.update]: true,
    [userActions.delete]: false
  },
  [permissionsKeyMap.facilities.children.hospital]: {
    [userActions.read]: true,
    [userActions.create]: true,
    [userActions.update]: true,
    [userActions.delete]: false
  },
  [permissionsKeyMap.facilities.children.orphanage]: {
    [userActions.read]: true,
    [userActions.create]: true,
    [userActions.update]: true,
    [userActions.delete]: false
  },
  // No donation permissions
  [permissionsKeyMap.donation.children.donations]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  [permissionsKeyMap.donation.children.addDonation]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  [permissionsKeyMap.donation.children.allDonations]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  [permissionsKeyMap.donation.children.donationSettings]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  [permissionsKeyMap.donation.children.donationPackages]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  [permissionsKeyMap.donation.children.urgentAppeals]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  // Limited settings permissions
  [permissionsKeyMap.settings.children.personal]: {
    [userActions.read]: true,
    [userActions.update]: true
  },
  [permissionsKeyMap.settings.children.branches]: {
    [userActions.read]: false,
    [userActions.update]: false
  },
  [permissionsKeyMap.settings.children.users]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false,
    [userActions.delete]: false
  },
  [permissionsKeyMap.settings.children.payment]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false
  },
  [permissionsKeyMap.settings.children.smtp]: {
    [userActions.read]: false,
    [userActions.create]: false,
    [userActions.update]: false
  }
};

// read action is default for all keys, based on this we will show the menu
// if we want to hide the menu then we need to remove the read action from the key

export const backendPermissions = {
  dashboard: {
    read: true
  },
  donors: {
    read: true,
    create: true,
    update: true,
    delete: true
  },
  projects: {
    read: true,
    create: true,
    update: true,
    delete: true
  },
  sponsorships: {
    read: true,
    create: true,
    update: true,
    delete: true
  },
  beneficiaries: {
    read: true,
    create: true,
    update: true,
    delete: true
  },
  sponsoredList: {
    read: true,
    create: true,
    update: true,
    delete: true
  },
  unsponsoredList: {
    read: true,
    create: true,
    update: true,
    delete: true
  },
  sponsorshipValues: {
    read: true,
    create: true,
    update: true,
    delete: true
  },
  school: {
    read: true,
    create: true,
    update: true,
    delete: true
  },
  donations: {
    read: true,
    create: true,
    update: true,
    delete: true
  },
  donationSettings: {
    read: true,
    create: false,
    update: false,
    delete: true
  },
  donationPackages: {
    read: true,
    create: true,
    update: true,
    delete: true
  },
  giftAid: {
    read: true,
    create: true,
    update: true,
    delete: true
  },
  organizationDetails: {
    read: true,
    update: true
  },
  users: {
    read: true,
    create: true,
    update: true,
    delete: true
  },
  branches: {
    read: true,
    create: false,
    update: false,
    delete: true
  },
  payment: {
    read: true,
    create: true,
    update: true
  },
  smtp: {
    read: true,
    create: true,
    update: true
  }
};

export const permissionsMap = [
  {
    key: permissionsKeyMap.donor.parent,
    label: 'Donors',
    children: [
      {
        key: permissionsKeyMap.donor.children.donors,
        label: 'Donors',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      }
    ]
  },
  {
    key: permissionsKeyMap.pledge.parent,
    label: 'Pledges',
    children: [
      {
        key: permissionsKeyMap.pledge.children.pledges,
        label: 'Pledges',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      }
    ]
  },
  // {
  //   key: permissionsKeyMap.project.parent,
  //   label: 'Projects',
  //   children: [
  //     {
  //       key: permissionsKeyMap.project.children.projects,
  //       label: 'Projects',
  //       actions: [
  //         userActions.read,
  //         userActions.create,
  //         userActions.update,
  //         userActions.delete
  //       ]
  //     }
  //   ]
  // },
  {
    key: permissionsKeyMap.sponsorship.parent,
    label: 'WeConnect',
    children: [
      {
        key: permissionsKeyMap.sponsorship.children.sponsorships,
        label: 'Sponsorships (General)',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.sponsorship.children.beneficiaries,
        label: 'All Beneficiaries',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.sponsorship.children.sponsorshipManagement,
        label: 'Sponsorship Management',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.sponsorship.children.sponsorshipDonation,
        label: 'Sponsorship Donations',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.sponsorship.children.sponsorshipReports,
        label: 'Reports & Insights',
        actions: [userActions.read]
      },
      {
        key: permissionsKeyMap.sponsorship.children.sponsorshipValues,
        label: 'Settings',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      }
    ]
  },
  {
    key: permissionsKeyMap.facilities.parent,
    label: 'WeFacilities',
    children: [
      {
        key: permissionsKeyMap.facilities.children.school,
        label: 'School',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.facilities.children.mosque,
        label: 'Mosque',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.facilities.children.hospital,
        label: 'Hospital',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.facilities.children.orphanage,
        label: 'Orphanage',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      }
    ]
  },
  {
    key: permissionsKeyMap.donation.parent,
    label: 'Donations',
    children: [
      {
        key: permissionsKeyMap.donation.children.donations,
        label: 'Donations (General)',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.donation.children.addDonation,
        label: 'Add Donation',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.donation.children.allDonations,
        label: 'All Donations',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.donation.children.donationSettings,
        label: 'Donation Settings',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.donation.children.donationPackages,
        label: 'Donation Packages',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.donation.children.urgentAppeals,
        label: 'Urgent Appeals',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      }
    ]
  },
  {
    key: permissionsKeyMap.settings.parent,
    label: 'Settings',
    children: [
      {
        key: permissionsKeyMap.settings.children.personal,
        label: 'Personal Settings',
        actions: [userActions.read, userActions.update]
      },
      {
        key: permissionsKeyMap.settings.children.branches,
        label: 'Branch Details',
        actions: [userActions.read, userActions.update]
      },
      {
        key: permissionsKeyMap.settings.children.users,
        label: 'Users',
        actions: [
          userActions.read,
          userActions.create,
          userActions.update,
          userActions.delete
        ]
      },
      {
        key: permissionsKeyMap.settings.children.payment,
        label: 'Payment',
        actions: [userActions.read, userActions.create, userActions.update]
      },
      {
        key: permissionsKeyMap.settings.children.smtp,
        label: 'SMTP',
        actions: [userActions.read, userActions.create, userActions.update]
      }
    ]
  }
];
